import { PACKAGE_VERSION } from "./version.js";
export let sourceInfo = Object.freeze({
    name: "js_sdk",
    version: PACKAGE_VERSION,
});
export function setSourceInfo(value) {
    sourceInfo = Object.freeze(value);
}
//# sourceMappingURL=sourceInfo.js.map